import PropTypes from 'prop-types';
import React from 'react';
import Flexbox from 'flexbox-react';
import { Menu, Dropdown, Icon } from 'antd';
import { cx, css } from 'emotion';
import { colorBorderGrey, colorVeryLightGrey } from 'styles/base';

const labelStyle = css`
    font-weight: 900;
    margin-right: 8px;
`;

const boxStyle = css`
    border: 1px solid ${colorBorderGrey};
    background-color: ${colorVeryLightGrey};
    padding: 8px;
    overflow-y: auto;
    font-size: 12px;
    border-radius: 4px;
`;

const menuStyle = css`
    max-height: 200px;
    overflow: auto;
`;

/**
 * A display box controlled by a dropdown list of items.  The selected item is
 * rendered in the box
 */
export default class DropdownBox extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        headerClass: PropTypes.string,
        headerComponent: PropTypes.any,
        contentClass: PropTypes.string,
        items: PropTypes.array, // list of strings - the labels shown in the dropdown
        label: PropTypes.string, // the label for the menu
        selectedItem: PropTypes.string, // the label of the currently selected item
        onSelectionChanged: PropTypes.func, // callback for when the dropdown selection changes
        children: PropTypes.any
    };

    handleMenuClick = (itemKey) => {
        this.props.onSelectionChanged(itemKey);
    };

    renderDropdownMenu() {
        if (this.props.items) {
            const items = this.props.items.map(itemKey => {
                return (
                    <Menu.Item key={itemKey}>
                        <div>{itemKey}</div>
                    </Menu.Item>
                );
            });
            const menu = (
                <Menu className={menuStyle} onClick={this.handleMenuClick}>{items}</Menu>
            );
            return (
                <Dropdown overlay={menu} trigger={['click']}>
                    <a className="ant-dropdown-link">
                        {this.props.selectedItem} <Icon type="down" />
                    </a>
                </Dropdown>
            );
        }
        return <div/>;
    }

    render() {
        let label = null;
        if (this.props.label) {
            label = (
                <div className={labelStyle}>{this.props.label}</div>
            );
        }
        return (
            <Flexbox flexDirection="column" flex="1" className={this.props.className}>
                <Flexbox className={this.props.headerClass} flexDirection="row" 
                    alignItems="center" flex="0 0 auto"
                >
                    {label}
                    {this.renderDropdownMenu()}
                    {this.props.headerComponent}
                </Flexbox>
                <Flexbox className={cx(boxStyle, this.props.contentClass)} flexDirection="column" flex="1 0 auto">
                    {this.props.children}
                </Flexbox>
            </Flexbox>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/core/DropdownBox.js